import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.5, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.2em] mb-3 ${light ? 'text-[#4cc3ff]' : 'text-primary'}`}>
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, text, light, className = '' }) => (
  <div className={`max-w-2xl ${className}`}>
    <Eyebrow light={light}>{eyebrow}</Eyebrow>
    <h2 className={`font-display font-bold text-3xl md:text-4xl leading-tight ${light ? 'text-white' : 'text-secondary'}`}>{title}</h2>
    {text && <p className={`mt-4 text-lg ${light ? 'text-white/70' : 'text-slate-600'}`}>{text}</p>}
  </div>
);

export const Container = ({ children, className = '' }) => (
  <div className={`mx-auto w-full max-w-6xl px-5 md:px-8 ${className}`}>{children}</div>
);

export const PageHero = ({ eyebrow, title, text }) => (
  <section className="relative bg-ink grid-bg text-white pt-40 pb-20 overflow-hidden">
    <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-secondary/40 blur-3xl" aria-hidden />
    <Container className="relative">
      <Eyebrow light>{eyebrow}</Eyebrow>
      <h1 className="font-display font-bold text-4xl md:text-6xl max-w-3xl leading-[1.05]">{title}</h1>
      {text && <p className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl">{text}</p>}
    </Container>
  </section>
);
